/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
// import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import template from "./ns-stepper.html";
import "@nuskin/ns-style-elements";
// import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn';

class NsStepper extends PolymerElement {
  static get is() {
    return "ns-stepper";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      labels: {
        type: Array
      },

      selected: {
        type: Number,
        value: 0,
        notify: true,
        reflectToAttribute: true,
        observer: "_getLabelForMobile"
      },

      _children: {
        type: Array
      },

      _stepDelimiters: {
        type: Array
      },

      labelForMobile: {
        type: String
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this.$.items.addEventListener("dom-change", () => {
      this._children = this.shadowRoot.querySelectorAll("ns-step");

      this.$.nsStepContainer.children[0].icon = "nuskin:icon-stepper-current";
    });
  }

  next() {
    if (this.selected === this.shadowRoot.querySelectorAll("ns-step").length)
      return;
    this._children[this.selected]._next();

    if (this.selected != this._children.length - 1) {
      this._children[this.selected + 1].icon = "nuskin:icon-stepper-current";
      this.selected += 1;
    }
  }

  previous() {
    if (this.selected === 0) return;
    this._children[this.selected - 1]._previous();

    this._children[this.selected].icon = "nuskin:icon-stepper-future";
    this._children[this.selected - 1].icon = "nuskin:icon-stepper-current";

    this.selected -= 1;
  }

  _computeTrueOrFalse(index) {
    let trueorfalse = index < this.labels.length - 1;
    return trueorfalse;
  }

  _getLabelForMobile(before, after) {
    this.labelForMobile = this.labels[this.selected];
  }
}

customElements.define(NsStepper.is, NsStepper);
